import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ContentDataTable } from "src/components/Common/ContentDataTable";
import { SectionNoData } from "src/components/Common/SectionNoData";
import { IConfig, ISetting, ISettingType } from "src/services/types";
import { columnsSettings } from "./ColumnsSettings";
import { toast } from 'react-toastify';
import { SearchTable } from "src/components/Common/SearchTable";
import { getSettingTypes, getSettings, updateSetting } from "src/services/settings-service";
import Select from 'react-select';
import { Button, Col, Row } from "reactstrap";
import { selectStyles } from "src/components/Common/common_styles_helper";
import { CreateEditSettingModal } from "./CreateEditSettingModal";

export const Settings = () => {
  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [settings, setSettings] = useState<ISetting[]>([]);
  const [settingTypes, setSettingTypes] = useState<ISettingType[]>([]);
  const [selectedSettingType, setSelectedSettingType] = useState<ISettingType | null>(null);
  const [createEditShowModal, setCreateEditShowModal] = useState(false);
  const [settingSelected, setSettingSelected] = useState<ISetting | null>(null);

  const [config, setConfig] = useState<IConfig>({
      page: 1,
      per_page: 10,
      search: "",
  });

  const getData = async (config: IConfig) => {
        setIsLoading(true);
        const res = await getSettings({...config, setting_type_id: selectedSettingType?.id || '' })
        setIsLoading(false);
        if (res.result === 'ok') {
            setTotalRows(res.data.pagination.total);
            setSettings(res.data.data);
        } else {
            toast(res.message, { type: 'error'});
        }
  }
  
  const handleActive = async (item: ISetting) => {

    const newSettings = settings.map((setting) => {
        if (setting.id === item.id) {
            return { ...setting, active: !item.active};
        }
        return setting;
    });
    setSettings(newSettings);

    const res = await updateSetting(item.id, { active: !item.active});
    if (res.result === 'ok') {
        toast('Setting updated successfully', { type: 'success'});
    } else {
        toast(res.message, { type: 'error'});
        const newSettings = settings.map((setting) => {
            if (setting.id === item.id) {
                return { ...setting, active: item.active };
            }
            return setting;
        });
        setSettings(newSettings);
    }
  }

  const getDataSettingTypes = async () => {
    const res = await getSettingTypes()
    if (res.result === 'ok') {
        setSettingTypes(res.data);
    } else {
        toast(res.message, { type: 'error'});
    }
  }

  const handleChange = (option: ISettingType) => {
    setSelectedSettingType(option);
  };

  const onCreateSetting = () => {
    setSettingSelected(null);
    setCreateEditShowModal(true);
  }

  const onEdit = (setting: ISetting) => {
    setSettingSelected(setting);
    setCreateEditShowModal(true);
  }
 
  useEffect(() => {
    getData(config);
  }, [config, selectedSettingType]);

  useEffect(() => {
    getDataSettingTypes();
  }, []);

  return (
    <>
      <div className="page-content" style={{height: '100vh'}} >
          <h3 className="mb-4 text-primary">Settings</h3>
          <Row>
              <Col sm={6} className="pb-3">
                <h6>Setting Types</h6>
                <Select
                    isClearable
                    isSearchable
                    styles={selectStyles}
                    getOptionLabel={(option: ISettingType) => option.name}
                    getOptionValue={(option: ISettingType) => option.id}
                    options={settingTypes}
                    value={selectedSettingType}
                    onChange={handleChange}
                />
              </Col>
              <Col sm={6} className="d-flex justify-content-end align-items-end" >
                  <div className=" d-flex justify-content-center align-content-center gap-2">
                    <SearchTable 
                        onSearch={(search) => setConfig({ ...config, search, page: 1 })}
                        loading={isLoading && !!config.search}
                    />
                    <div style={{marginTop: '1px'}}>
                      <Button color="primary"  onClick={() => onCreateSetting()}>
                        <div className="d-flex justify-content-center align-items-center">
                          Create Setting 
                          <i className="fas fa-plus ms-2"></i>
                        </div>
                      </Button>
                    </div>
                  </div>
              </Col>
          </Row>
         
          <ContentDataTable isLoading={isLoading}>
              <DataTable
                  customStyles={{}}
                  columns={columnsSettings(config, handleActive, onEdit)}
                  data={settings}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  responsive
                  onChangeRowsPerPage={(per_page) => setConfig({ ...config, per_page, page: 1 })}
                  onChangePage={(page) => setConfig({ ...config, page })}
                  paginationDefaultPage={config.page}
                  paginationPerPage={config.per_page}
                  paginationRowsPerPageOptions={[10, 20, 50, 100]}
                  noDataComponent={
                      <SectionNoData
                          onRefresh={() => getData(config)}
                          isLoading={isLoading}
                      />
                  }
              />
          </ContentDataTable>
      </div>

      <CreateEditSettingModal
          show={createEditShowModal}
          onClose={() => setCreateEditShowModal(false)}
          setting={settingSelected}
          settingTypes={settingTypes}
          onRefresh={() => getData(config)}
      />

    </>
  )
}
